import React, { useState, useEffect } from "react";
import { FiEdit2, FiTrash2, FiPlus, FiHome, FiX, FiMapPin, FiChevronRight } from "react-icons/fi";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl } from "../baseurl";  
import { Link } from "react-router-dom";


function ShippingAddress() {
  const [addresses, setAddresses] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editAddress, setEditAddress] = useState(null);
  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    country: "India",
    postal_code: "",
  });

  const user_id = localStorage.getItem("customerId") || 1;

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  });

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    try {
      const res = await axios.get(`${baseurl}getAddressesByUserId/${user_id}`);
      if (res.data.success) setAddresses(res.data.addresses);
    } catch (err) {
      Toast.fire({ icon: "error", title: "Failed to fetch addresses" });
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const openNewForm = () => {
    setEditAddress(null);
    setFormData({
      full_name: "",
      phone: "",
      address_line1: "",
      address_line2: "",
      city: "",
      state: "",
      country: "India",
      postal_code: "",
    });
    setShowForm(true);
  };

  const handleSave = async () => {
    try {
      if (!formData.full_name || !formData.phone || !formData.address_line1) {
        Toast.fire({ icon: "error", title: "Please fill all required fields" });
        return;
      }

      if (editAddress) {
        const res = await axios.put(`${baseurl}updateAddress/${editAddress.id}`, formData);
        if (res.data.success) Toast.fire({ icon: "success", title: "Address updated" });
      } else {
        const res = await axios.post(`${baseurl}addAddress`, { user_id, ...formData });
        if (res.data.success) Toast.fire({ icon: "success", title: "Address added" });
      }

      setShowForm(false);
      fetchAddresses();
    } catch (err) {
      Toast.fire({ icon: "error", title: "Something went wrong!" });
    }
  };

  const handleEdit = (addr) => {
    setEditAddress(addr);
    setFormData(addr);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Delete this address?",
      text: "You won’t be able to recover it!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f54c4d",
      confirmButtonText: "Yes, delete it",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.delete(`${baseurl}deleteAddress/${id}`);
          if (res.data.success) {
            Toast.fire({ icon: "success", title: "Deleted successfully" });
            fetchAddresses();
          }
        } catch {
          Toast.fire({ icon: "error", title: "Failed to delete" });
        }
      }
    });
  };

  const handleSetDefault = async (id) => {
    try {
      const res = await axios.put(`${baseurl}setDefaultAddress/${id}`);
      if (res.data.success) {
        Toast.fire({ icon: "success", title: "Default address set" });
        fetchAddresses();
      }
    } catch {
      Toast.fire({ icon: "error", title: "Failed to update default" });
    }
  };

  return (
    <div className="address-container">
      <div className="address-header">
        {/* <h2>My Shipping Addresses</h2> */}

        <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
                <ol className="breadcrumb">
                  <li className={`breadcrumb-item active`} >
                        <Link to={`/`}> Home
                            <FiChevronRight className="breadcrumb-separator" />
                          </Link>
                      </li> 
                      <li className={`breadcrumb-item active pt2`} > 
                             My Shipping Addresses 
                      </li> 
                </ol>
              </nav>


        <button className="btn-add" onClick={openNewForm}>
          <FiPlus /> Add Address
        </button>
      </div>

      <div className="address-grid">
        {addresses.length === 0 ? (
          <div className="no-address">No addresses added yet.</div>
        ) : (
          addresses.map((addr) => (
            <div
              className={`address-card ${addr.is_default ? "default" : ""}`}
              key={addr.id}
            >
              <div className="address-icon">
                <FiHome />
              </div>
              <div className="address-content">
                <h5>{addr.full_name}</h5>
                <p className="phone">{addr.phone}</p>
                <p className="details">
                  {addr.address_line1}, {addr.address_line2 && `${addr.address_line2}, `}
                  {addr.city}, {addr.state}, {addr.country} - {addr.postal_code}
                </p>
              </div>
              <div className="address-actions">
                <button className="btn-edit" onClick={() => handleEdit(addr)}>
                  <FiEdit2 />
                </button>
                <button className="btn-delete" onClick={() => handleDelete(addr.id)}>
                  <FiTrash2 />
                </button>
              </div>
              {!addr.is_default && (
                <button
                  className="btn-default"
                  onClick={() => handleSetDefault(addr.id)}
                >
                  <FiMapPin /> Set Default
                </button>
              )}
              {addr.is_default && <span className="default-badge">Default</span>}
            </div>
          ))
        )}
      </div>

      {showForm && (
        <div className="modal-backdrop">
          <div className="modal-box" style={{maxHeight: "80vh", overflow: "auto"}}>
            <div className="modal-header">
              <h5 className="text-start m-0">{editAddress ? "Edit Address" : "Add Address"}</h5>
              {/* <button className="close-btn" onClick={() => setShowForm(false)}>
                <FiX />
              </button> */}
            </div>
            <div className="modal-body">
  <div className="row g-3">
    {[
      { label: "Full Name", name: "full_name" },
      { label: "Phone", name: "phone" },
      { label: "Address Line 1", name: "address_line1" },
      { label: "Address Line 2", name: "address_line2" },
      { label: "City", name: "city" },
      { label: "State", name: "state" },
      { label: "Country", name: "country" },
      { label: "Postal Code", name: "postal_code" },
    ].map((f, i) => (
      <div className="col-md-6" key={i}>
        <div className="form-floating">
          <input
            type="text"
            className="form-control shadow-sm"
            id={f.name}
            name={f.name}
            value={formData[f.name] || ""}
            onChange={handleChange}
            placeholder={f.label}
          />
          <label htmlFor={f.name}>{f.label}</label>
        </div>
      </div>
    ))}
  </div>
   
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary btn-sm ms-2" onClick={() => setShowForm(false)}>
                Cancel
              </button>
              <button className="btn btn-primary btn-sm ms-2" onClick={handleSave}>
                {editAddress ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ShippingAddress;
